import { render, staticRenderFns } from "./update-research-group-detail.html?vue&type=template&id=e642bd6a&scoped=true&external"
import script from "./update-research-group-detail.js?vue&type=script&lang=js&external"
export * from "./update-research-group-detail.js?vue&type=script&lang=js&external"
import style0 from "./update-research-group-detail.scss?vue&type=style&index=0&id=e642bd6a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e642bd6a",
  null
  
)

export default component.exports